/* global translate */
import React from 'react'
import './poll_list.css';
const RxPollListItem = global.rootRequire('components/shares/pollComponent/pollListItem/poll_list_item').default
const {changeColorSVG,isLeaderCheck} = global.rootRequire('classes/ulti')
export const renderComponent = (vm) =>
<div className='zlist-poll-place'>
  <div className='zlist-poll-title'>
    <div className='zmore-btn-back_place-poll' onClick={e => vm.props.backBtnClick()}>
      <i className='icon-arrow-left' ></i>
    </div>
    {translate('Group board')}
    {
      vm.state.group.owner_uin.toString() ===  vm.userid.toString() &&
      <div className='zmore-btn-create' onClick={e => vm.createPollClick()}>
        <img src={changeColorSVG('./images/default/static/plus.svg')} alt='icon-like' className=''  />
      </div>
    }
  </div>
  <div className='zlist-poll-header'>
    <div className='zlist-poll-header-item'>
      <div>{translate('Poll')}</div>
      <div className='zpollmem-option-border'></div>
    </div>
  </div>
  <div className='zlist-poll-content'>
    {
      (vm.state.polls && vm.state.polls.length > 0) ? 
      vm.state.polls.map(ele =>
        <div key={ele.poll_id}>
          <RxPollListItem pollInfo={ele} token={vm.props.token} />
        </div>
      ):
      <div className='zpoll-emty'>
        <img className='icon176x80 filter_img_class' src={changeColorSVG('./images/default/icons/background-empty-vote.svg')} alt='' />
        <div className='zgroup-emty_text' >
          {translate('Create poll to help the group decide faster.')} 
        </div>
        {
          vm.state.group.owner_uin.toString() ===  vm.userid.toString() &&
          <div className='zPoolList-btn' onClick={e => vm.createPollClick()}>{translate('Create Poll')}</div>
        }
      </div>
    }
  </div>
</div>